import o from "./SidebarElement.vue2.js";
import "./SidebarElement.vue3.js";
import t from "../../_virtual/_plugin-vue_export-helper.js";
const a = /* @__PURE__ */ t(o, [["__scopeId", "data-v-e7568968"]]);
export {
  a as default
};
